import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Navigation, {
  NavigationBarIcon,
  NavigationLink,
} from '@fuww/components/src/Navigation';
import Anchor from '@fuww/components/src/Anchor';
import { useIntl } from 'react-intl';
import SearchIcon from '@fuww/components/src/Icons/Search';
import MailIcon from '@fuww/components/src/Icons/Mail';
import SiteContext from '../SiteContext';
import UserTab from './UserTab';
import messages from '../../lib/messages';
import getTabs from '../../data/navigation';
import LinkAndAnchor from '../LinkAndAnchor';
import getLandingRouteFromPath from '../../lib/getLandingRouteFromPath';

const SimpleTopAppBar = ({
  onOpenDrawer,
  topAppBarTitle,
  useRouter,
}) => {
  const intl = useIntl();
  const {
    newsboard, locale, jobsLanding, lite, hasNews,
  } = useContext(SiteContext);

  const tabs = getTabs(newsboard, locale, jobsLanding, lite, hasNews).map(({
    id,
    href: originalHref,
    router,
    route,
    params,
    target,
  }) => {
    const hrefKey = `${id}.href`;
    const label = intl.formatMessage(messages[id]);
    const hrefTranslation = messages[hrefKey];
    const href = hrefTranslation
      ? intl.formatMessage(hrefTranslation) : originalHref;

    return router && useRouter
      ? (
        <LinkAndAnchor
          route={route}
          params={params}
          passHref
          key={id}
        >
          <NavigationLink
            tag="span"
            target={target}
            variant="button"
          >
            {label}
          </NavigationLink>
        </LinkAndAnchor>
      )
      : (
        <Anchor
          href={href}
          target={target}
          key={id}
          styled
        >
          <NavigationLink
            tag="span"
            variant="button"
          >
            {label}
          </NavigationLink>
        </Anchor>
      );
  });

  return (
    <Navigation
      onOpenDrawer={onOpenDrawer}
      topAppBarTitle={topAppBarTitle}
      tabs={tabs}
      userTabs={(
        <>
          <LinkAndAnchor
            {...getLandingRouteFromPath(intl
              .formatMessage(messages['newsletter.href']), 'newsletter')}
            href={intl.formatMessage(messages['newsletter.href'])}
            aria-label="Newsletter"
          >
            <NavigationBarIcon
              collapsible
            >
              <MailIcon />
            </NavigationBarIcon>
          </LinkAndAnchor>
          {lite ? null : (
            <LinkAndAnchor
              route="search"
              aria-label="Search page"
              passHref
            >
              <NavigationBarIcon
                collapsible
              >
                <SearchIcon />
              </NavigationBarIcon>
            </LinkAndAnchor>
          )}
          <UserTab />
        </>
      )}
    />
  );
};

SimpleTopAppBar.propTypes = {
  onOpenDrawer: PropTypes.func,
  topAppBarTitle: PropTypes.node,
  useRouter: PropTypes.bool,
};

SimpleTopAppBar.defaultProps = {
  onOpenDrawer: () => {},
  topAppBarTitle: undefined,
  useRouter: true,
};

export default SimpleTopAppBar;
